import { useContext, useMemo } from 'react'

import {
  Box,
  Button,
  Icon,
  Text,
  ThemeColors,
} from '@fairfashion/design-system'

import { GlobalDataContext } from '../../contexts/globalData'
import { CompanySegment } from '../../sdk/common/company.enum'

import * as Styles from './map-legend.styles'
import { MapLegendProps } from './map-legend.types'
import { deforestationLegend } from './map-legend.utils'

export const MapLegend = ({ showLegend, setShowLegend }: MapLegendProps) => {
  const { companySegmentType } = useContext(GlobalDataContext)

  const segmentsLegend = useMemo(
    () =>
      Object.keys(companySegmentType).map((key) => {
        return {
          color: companySegmentType[key as CompanySegment].color,
          label: companySegmentType[key as CompanySegment].translate,
        }
      }),
    [companySegmentType],
  )

  return (
    <Styles.MapLegendContainer open={showLegend}>
      <Box
        direction="column"
        width="100%"
        height="100%"
        gap={2}
        overflow="auto"
        paddingX={1}
      >
        <Box width="100%" justifyContent="space-between">
          <Text fontWeight={500} size="small">
            Legenda
          </Text>
          <Button
            variant="text"
            padding="2px"
            onClick={() => setShowLegend(false)}
          >
            <Icon name="close" />
          </Button>
        </Box>
        <Box overflow="auto" direction="column" gap={1}>
          <Styles.LegendAccordion header="Segmentos">
            <Box
              direction="column"
              width="100%"
              flex={1}
              gap={1}
              overflow="auto"
            >
              {segmentsLegend.map((item, index) => (
                <Box gap={1} key={`segment-item-${index}`} alignItems="center">
                  <Icon
                    name="map_pin2_fill"
                    color={item.color as ThemeColors}
                    size={24}
                  />
                  <Text size="small">{item.label}</Text>
                </Box>
              ))}
            </Box>
          </Styles.LegendAccordion>

          <Styles.LegendAccordion header="Desmatamento">
            <Box>
              <Text size="small">Incremento anual no desmatamento</Text>
            </Box>
            <Box
              direction="column"
              width="100%"
              flex={1}
              gap={1}
              overflow="auto"
              marginTop={2}
            >
              {deforestationLegend.map((item, index) => (
                <Box gap={1} key={`legend-item-${index}`}>
                  <Box
                    width="20px"
                    height="20px"
                    backgroundColor={item.color as ThemeColors}
                  />
                  <Text size="small">{item.label}</Text>
                </Box>
              ))}
            </Box>
          </Styles.LegendAccordion>
        </Box>
      </Box>
    </Styles.MapLegendContainer>
  )
}
